module.exports = __webpack_public_path__ + "img/united.d2c06306.webp";